import { LanguageInfoBM, MapEngine } from '@cue/api';

export interface ResourceStatus {
  status: number;
  name: string;
  color: string;
}

export enum ResourceAvailabilityRestrictionsModeId {
  DoNotModify = 1,
  AskBeforeModifying = 2,
  AutomaticallyEnforce = 3,
}

export interface AddinApiConfig {
  configured: boolean;
  adminSettingsUrl?: string;
  cueSolutionValidLicence: boolean;
  configuration: {
    mapEngine: MapEngine;
    languages: LanguageInfoBM[];
    googleAnalyticsEnabled: boolean;
    googleAnalyticsKey?: string;
    prompt: string;
    assistURL: string;
    clientId: string;
    connectionAgentServerTypeId: number;
    connectionAgentId: number;
    tenantId: string;
    statusesList: ResourceStatus[];
    isCAFromAddin: boolean;
    resourceAvailabilityRestrictionsModeId?: ResourceAvailabilityRestrictionsModeId;
    enforceResourceAvailabilityRestrictionsInOutlook?: boolean;
    installationName: string;
  };
}

export function getResourceAvailabilityRestrictionsMode(
  configuration: AddinApiConfig['configuration']
): ResourceAvailabilityRestrictionsModeId {
  return (
    configuration.resourceAvailabilityRestrictionsModeId ??
    (configuration.enforceResourceAvailabilityRestrictionsInOutlook
      ? ResourceAvailabilityRestrictionsModeId.AutomaticallyEnforce
      : ResourceAvailabilityRestrictionsModeId.DoNotModify)
  );
}
